<mat-card (click)="$event.stopPropagation()" class="cardP">
    <mat-card-title>
        {{data?.title}}
    </mat-card-title>
    <mat-card-content>
        <p class="text-justify">{{data?.content}}</p>
    </mat-card-content>
</mat-card>
<div class="action">
    <button mat-icon-button [disabled]="!tourService.hasPrev(data)" (click)="tourService.prev()">
        <mat-icon>chevron_left</mat-icon>
    </button>
    <button mat-icon-button [disabled]="!tourService.hasNext(data)" (click)="tourService.next()">
        <mat-icon>chevron_right</mat-icon>
    </button>

    <button mat-button class="final" (click)="tourService.end()">{{data?.endBtnTitle}}</button>

</div>